import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-map-others',
  templateUrl: './edit-map-others.component.html',
  styleUrls: ['./edit-map-others.component.scss'],
})
export class EditMapOthersComponent implements OnInit {
  @Input() filter: string = '';
  @Input() isEditMode: boolean = false;
  @Input() item: any = null;
  @Output() saved = new EventEmitter<void>();

  public title: string = '';
  public description: string = '';
  public icon: string = '';

  // Promo-related icons for selection
  public promoIcons: string[] = [
    'fa-solid fa-crown',
    'fa fa-thumbs-up',
    'fas fa-gem',
    'fa-solid fa-lightbulb',
    'fa-solid fa-trophy',
    'fa-solid fa-fire',
    'fa-solid fa-medal',
    'fa-solid fa-heart',
    'fas fa-bolt',
    'fa-solid fa-star',
    'fa-solid fa-gift',
    'fa-solid fa-tag',
    'fa-solid fa-percent',
    'fa-solid fa-money-bill-wave',
    'fa-solid fa-calendar-check',
    'fa-solid fa-clock',
    'fa-solid fa-bell',
    'fa-solid fa-certificate',
  ];

  constructor(
    public modal: NgbActiveModal,
    private customerService: CustomerService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.isEditMode && this.item) {
      this.title = this.item.title || '';
      this.description = this.item.description || '';
      this.icon = this.item.icon || '';
    }
  }

  onIconSelected(icon: string) {
    // Toggle selection - if same icon clicked, deselect it
    if (this.icon === icon) {
      this.icon = '';
    } else {
      this.icon = icon;
    }
  }

  save() {
    if (!this.title || !this.description) {
      this.toastr.error('Please fill in title and description');
      return;
    }

    const payload: any = {
      filter: this.filter,
      title: this.title,
      description: this.description,
      icon: this.icon || '',
    };

    if (this.isEditMode && this.item?.id) {
      payload.id = this.item.id;
    }

    this.customerService.createMapOthers(payload).subscribe({
      next: () => {
        this.toastr.success(
          this.isEditMode
            ? 'Item updated successfully'
            : 'Item created successfully'
        );
        this.saved.emit();
        this.modal.close();
      },
      error: (error) => {
        console.error('Error saving item:', error);
        this.toastr.error('Failed to save item');
      },
    });
  }

  cancel() {
    this.modal.dismiss('Cancel click');
  }
}

